import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {}

const { onRequest, onSuccess, onFailure } = rootActions.properties.getPropertyUploadURL

function* getPropertyUploadURLTask(args: TaskAction) {
    try {
        const response = yield axios.get(`/attachments/properties/upload-url`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* getPropertyUploadURL(): any {
    yield takeLatest<TaskAction>(onRequest, getPropertyUploadURLTask)
}

export default getPropertyUploadURL
